<template>
  <div class="mx-3 filters">
    <v-form ref="form">
      <!-- ======================= Search Filters ========================== -->
      <v-layout row wrap v-if="isAllowedSearchFilters()">
        <v-flex xs12 class="my-1">
          <v-subheader class="subheading font-weight-bold pl-0 white--text">
            <v-icon>{{ $vuetify.icons.rms_active }}</v-icon>&ensp;
            <span>{{ $t('rms.filters.search_category_label') }}</span>&ensp;
            <v-divider></v-divider>
          </v-subheader>
        </v-flex>
        <v-divider></v-divider>
        <v-flex xs12>
          <!-- ******** Geners ********** -->
          <v-autocomplete
            :items="genreList"
            :prepend-icon="$vuetify.icons.rms_film"
            v-model="genres"
            hide-details
            item-text="name"
            item-value="id"
            label="Genre"
            class="text-truncate"
            multiple
            outline
            single-line
            chips
            deletable-chips
            @input="searchGenre=null"
            :search-input.sync="searchGenre"
            ref="genres"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item,'genres')"
              >{{ data.item.name }}</v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>

        <!-- ******** Types ********** -->
        <v-flex xs12>
          <v-select
            :items="typesList"
            :prepend-icon="$vuetify.icons.rms_file"
            v-model="types"
            hide-no-data
            hide-details
            item-text="name"
            item-value="id"
            label="Type"
            class="text-truncate"
            multiple
            outline
            single-line
            chips
            deletable-chips
            @input="searchType=null"
            :search-input.sync="searchType"
            ref="types"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item,'types')"
              >{{ data.item.name }}</v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>

        <!-- ******** Formats ********** -->
        <v-flex xs12>
          <v-select
            :items="formatList"
            :prepend-icon="$vuetify.icons.rms_desktop"
            v-model="formats"
            hide-no-data
            hide-details
            item-text="name"
            item-value="id"
            label="Format"
            class="text-truncate"
            multiple
            outline
            single-line
            chips
            deletable-chips
            @input="searchFormat=null"
            :search-input.sync="searchFormat"
            ref="formats"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item,'formats')"
              >{{ data.item.name }}</v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>

        <!-- ******** Release Year ********** -->
        <v-flex xs12>
          <v-select
            :items="releaseYearList"
            :prepend-icon="$vuetify.icons.rms_tag"
            v-model="release_year"
            hide-no-data
            hide-details
            item-text="name"
            item-value="id"
            label="Release Year"
            class="text-truncate"
            outline
            single-line
            chips
            @input="searchReleaseYearList=null"
            :search-input.sync="searchReleaseYearList"
            deletable-chips
            ref="releaseYear"
          ></v-select>
        </v-flex>

        <!-- ******** Movie title ********** -->
        <v-flex xs12>
          <v-text-field
            :prepend-icon="$vuetify.icons.rms_movie"
            single-line
            v-model="title"
            hide-details
            label="Movie title"
            outline
            @keyup.enter="closeKeypad()"
            ref="title"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <!-- ================= Availibility Filters ======================= -->
      <v-layout row wrap>
        <v-flex xs12 class="my-1">
          <v-subheader class="subheading font-weight-bold pl-0 white--text">
            <v-icon>{{ $vuetify.icons.rms_active }}</v-icon>&ensp;
            <span>{{ $t('rms.filters.available_category_label') }}</span>&ensp;
            <v-divider></v-divider>
          </v-subheader>
        </v-flex>
        <v-flex xs12>
          <!-- ******** Rights ********** -->
          <v-autocomplete
            :items="rightsList"
            :prepend-icon="$vuetify.icons.rms_tag"
            v-model="rights"
            hide-details
            item-text="name"
            item-value="id"
            multiple
            label="Rights"
            class="text-truncate"
            outline
            single-line
            chips
            deletable-chips
            @input="searchRight=null"
            :search-input.sync="searchRight"
            ref="rights"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item,'rights')"
              >{{ data.item.name }}</v-chip>
            </template>

            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <!-- ******** Countries ********** -->
          <v-autocomplete
            :items="countriesList"
            :prepend-icon="$vuetify.icons.rms_map"
            v-model="countries"
            hide-details
            item-text="name"
            item-value="id"
            multiple
            label="Countries"
            class="text-truncate"
            outline
            single-line
            chips
            deletable-chips
            @input="searchCountry=null"
            :search-input.sync="searchCountry"
            ref="countries"
          >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="remove(data.item,'countries')"
              >{{ data.item.name }}</v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12>
          <!-- ******** Contract types (EXCL./NON-EXCL.) ********** -->
          <v-select
            :items="contractTypeList"
            :prepend-icon="$vuetify.icons.rms_tag"
            v-model="exclusive"
            hide-no-data
            hide-details
            item-text="name"
            item-value="id"
            label="Exclusive/Non-Exclusive"
            class="text-truncate"
            outline
            single-line
            chips
            @input="searchContract=null"
            :search-input.sync="searchContract"
            deletable-chips
            ref="contractTypes"
          ></v-select>
        </v-flex>
      </v-layout>

      <!-- ******** Actions ********** -->
      <v-layout row wrap class="mt-4">
        <v-flex xs6 class="pa-1">
          <v-btn
            dark
            large
            block
            color="grey darken-2"
            @click="reset()"
          >{{$t('rms_filter_reset_button_label')}}</v-btn>
        </v-flex>
        <v-flex xs6 class="pa-1">
          <v-btn
            block
            large
            color="orange darken-2"
            @click="submit()"
          >{{ $t('rms_filter_apply_label') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import { EventBus } from "@/event-bus";
export default {
  name: "FilterMenu",
  data() {
    return {
      searchRight: null,
      searchCountry: null,
      searchGenre: null,
      searchType: null,
      searchFormat: null,
      searchContract: null,
      searchReleaseYearList: null
    };
  },
  props: ["dialog"],
  computed: {
    ...mapState({
      genreList: state => state.tag.film_genre,
      typesList: state => state.tag.film_type,
      countriesList: state => state.tag.film_countries,
      rightsList: state => state.tag.film_rights,
      formatList: state => state.tag.film_format,
      contractTypeList: state => state.tag.film_contract_type,
      releaseYearList: state => state.tag.film_release_year,
      session_mode: state => state.app.session_mode
    }),
    ...mapFields("filter", {
      rights: "selected.rights",
      countries: "selected.countries",
      genres: "selected.genres",
      types: "selected.types",
      formats: "selected.formats",
      title: "selected.title",
      exclusive: "selected.exclusive",
      release_year: "selected.release_year"
    }),
    ...mapGetters({
      filters: "filter/getApplied",
      is_filters_applied: "filter/is_applied",
      availLink: "availLink/get"
    }),

    dialogStatus: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    closeKeypad() {
      this.$refs.title.blur();
    },

    async getTags(tag_type) {
      await this.$store.dispatch("tag/list", {
        tag_type
      });
    },

    async submit() {
      this.$store.commit("filter/set_filters");
      this.is_filters_applied
        ? this.getFilteredResult()
        : await this.$store.dispatch("film/list");
      this.dialogStatus = false;
    },

    async getFilteredResult() {
      await this.$store.dispatch("filter/listFilms", {
        rights: this.rights,
        countries: this.countries,
        genres: this.genres,
        types: this.types,
        formats: this.formats,
        exclusive: this.exclusive,
        title: this.title,
        release_year: this.release_year
      });
    },

    async reset() {
      if (
        this.session_mode == this.DEFINES.AVAIL_SESSION_MODE &&
        !this.availLink.is_search_filters_allowed
      ) {
        // It means that do not reset the hide filters (Ex. search filters)
        this.$store.commit("filter/resetOnlyAvailabilityFilters");
      } else {
        await this.$store.dispatch("film/list");
        await this.$store.commit("filter/resetAllFilters");
      }
    },

    remove(item, tags) {
      this[tags] = this[tags].filter(tagid => {
        return tagid !== item.id;
      });
    },

    isAllowedSearchFilters() {
      // If session is in avail mode then check refine search is allow or not
      if (
        this.session_mode == this.DEFINES.AVAIL_SESSION_MODE &&
        !this.availLink.is_search_filters_allowed
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
.v-input__icon--prepend .v-icon {
  color: #fb8c00 !important;
}
.filters
  .v-text-field.v-text-field--enclosed
  > .v-input__control
  > .v-input__slot {
  padding: 0px 3px !important;
  border: none !important;
}

.v-input__control {
  display: inlines !important;
  -webkit-box-orient: vertical;
}
.filters .v-input__icon--clear .v-icon--link {
  font-size: 15px;
}

.filters .v-input__icon .v-input__icon--append .v-icon .mdi-menu-down {
  color: pink !important;
}
</style>
